<script lang="ts">
  import { cn } from '@shared/utils';

  import type { ContentBlock } from '../types';
  import Embed from './embed.svelte';
  import Header from './header.svelte';
  import Image from './image.svelte';
  import NestedList from './nested-list.svelte';
  import Paragraph from './paragraph.svelte';
  import Quote from './quote.svelte';

  export let blocks: ContentBlock[] = [];
  export let size: 'base' | 'lg' | 'xl' = 'base';
  export let containerClasses = '';

  const classes = {
    base: 'text-base md:text-lg',
    lg: 'text-lg md:text-xl',
    xl: 'text-xl',
  };

  const blocksComponents = {
    header: Header,
    paragraph: Paragraph,
    nestedlist: NestedList,
    quote: Quote,
    image: Image,
    embed: Embed,
  };
</script>

<section class="{cn(classes[size], containerClasses)}">
  {#each blocks as block}
    {@const componentContent = blocksComponents[block.type]}

    {#if componentContent}
      <div class="mb-4 last:mb-0">
        <svelte:component this="{componentContent}" data="{block.data}" id="{block?.id}" />
      </div>
    {/if}
  {/each}
</section>
